import React, { useContext, useEffect, useState } from 'react';

import { observer } from "mobx-react-lite";
import { IInstallation } from 'models/Installation/Installation';
import Agent from "../../api/Agent";
import { displayDate } from "../../lib/utilities";
import { RootStoreContext } from "../../stores/RootStore";
import Autocomplete from "../Inputs/Autocomplete";
import { ComboBoxProps, OptionType } from "./ComboBox";

interface OwnProps extends ComboBoxProps {
  filterIds?: string[]
  entityStateId?: string
  canAddNew?: boolean
  onFetchSuccess?:(data: IInstallation[]) => void
}

type Props = OwnProps

const InstallationAutoCompleteInput: React.FC<Props> = ({entityStateId, filterIds, canAddNew= true, onFetchSuccess, ...rest}) => {
  // Mobx
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore
  const {installationsList} = rootStore.installationStore

  // Local state
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([] as OptionType[]);

  // Use Effect
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = new URLSearchParams()
        params.append('limit', '100000')
        params.append('offset', `0`)
        const {modelsDto} = await Agent.Installations.list(params)
        if (modelsDto && modelsDto.length > 0 ) onFetchSuccess && onFetchSuccess(modelsDto)
        setAutoCompleteOptions(() => {
          const opts = modelsDto
          .filter(opt => opt.entityStateId === entityStateId || !entityStateId)
          .map(opt => {
            return {
              id: opt.id,
              name: `${opt.consumerName ?? 'No Consumer'} - ${opt.technicianName ?? 'No Technician'} ${displayDate(opt.datePerformed) ?? 'No Date'}`.trim()
            }
          }).sort((optA, optB) => optA.name > optB.name ? 1 : -1)
          // @ts-ignore
          if (canAddNew) opts.unshift({id: 0, name: '+ New Installation'})
          return opts
        })
      } catch (e) {

      }
    }

    fetchData()

  }, [installationsList, entityStateId]);

  const createNew = () => {
    openModal('InstallationModal', {header: 'New Installation'})
  }

  const handleChange = (e) => {
    e.id === 0 ? createNew() : !!rest.onChange && rest.onChange(e)
  }

  const optionsFilter = (option) => {
    if (filterIds) {
      return !filterIds.includes(option.id)
    } else {
      return true;
    }
  }

  return (
    <Autocomplete  {...rest} options={autoCompleteOptions.filter((opt) => optionsFilter(opt))} label={'Installation'}
      onChange={handleChange}></Autocomplete>
  );
};
export default observer(InstallationAutoCompleteInput);
